// extracted by mini-css-extract-plugin
export default {"popup":"DeleteMemberPopup_popup__RnovA","btns":"DeleteMemberPopup_btns__DC+6o","submitting":"DeleteMemberPopup_submitting__BZgCa"};